import { module } from 'modujs';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

export default class extends module {
    constructor(m) {
        super(m);
    }
    init() {
        this.onResizeBind = this.onResize.bind( this );

        if( window.innerWidth < 768) return;

        this.scroll = this.modules.Scroll.main.lenis;
        this.pins = [...this.el.querySelectorAll( '[data-column-pin]')];
        this.movables = [...this.el.querySelectorAll( '[data-column-pin-movable]')];
        this.onResize();

        window.addEventListener( 'resize', this.onResizeBind );

        this.isScrolling = true;

        this.scroll.on( 'scroll', args => {
            if( this.isScrolling ){
                this.movables.forEach( movable => {
                    movable.style.transform = 'translateY(' + this.scroll.animatedScroll + 'px)'
                } );
            }
        });


        ScrollTrigger.create({
            scroller: this.modules.Scroll.main.el,
            trigger: this.el,
            pin: this.pins[0],
            start: 'top top',
            end: 'bottom bottom',
            scrub: 1,
            /*markers: true,*/
            pinType: 'transform'
        });
        ScrollTrigger.create({
            scroller: this.modules.Scroll.main.el,
            trigger: this.el,
            pin: this.pins[1],
            start: 'top top',
            end: 'bottom bottom',
            scrub: 1,
            pinType: 'transform',
            onLeave: () => {
                this.isScrolling = false;
            },
            onEnterBack: () => {
                this.isScrolling = true;
            },
        });
    }
    onResize(){
        this.pins.forEach( pin => pin.style.height = window.innerHeight + 'px' );
    }
    destroy(){
        window.removeEventListener( 'resize', this.onResizeBind );
    }
}
